let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iEH96")).then(() => parcelRequire('dhOKV'));